<main class="flex justify-content-center wrapper-content mt-3  flex-column">
  <header class="lg:w-full w-11 mx-auto ">
    <h1 class="header-title mb-0 font-size-title font-weight-regular">{{ translations?.header }}</h1>
    <h2 class="subheader-title mt-1 font-size-title font-weight-regular">
      {{ translations?.subHeader }}
      <span class="font-bold"> {{ nombreTramite() }}</span>
    </h2>
  </header>
  <div class="flex w-full lg:gap-5 gap-3 justify-content-between lg:justify-content-center
   align-items-center lg:flex-row flex-column mx-auto">

    <section class="lg:w-10 w-full" style="height: 70dvh;">

      @if (url()){
        <iframe *ngIf="!isMobile else movil" class="w-full h-full"
                [src]="url() | safeResource : 'resourceUrl'"></iframe>
      }@else {
        <p-skeleton height="100%"></p-skeleton>
      }

    </section>
  </div>
  <div class="col-12 flex justify-content-center">
    <button class="btn flex align-items-center" pButton type="button"
            (click)="redirectToHome()">
      <span>{{ translations?.volver }}</span>
    </button>
  </div>
</main>


<ng-template #movil>
  <div class="w-full h-20rem flex justify-content-center align-items-center bg-blue-100">
    <a target="_blank" [href]="url() | safeResource : 'resourceUrl'" class="btn px-3 py-2  no-underline">
      <i class="pi pi-download"></i>
      <span class="px-2">{{ translations()?.descargar }}</span>
    </a>
  </div>
</ng-template>
